import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_8 = {
  key: 0,
  class: "route"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 1,
  class: "text-muted"
}

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

import ResourceTable from '@shell/components/ResourceTable';
import Loading from '@shell/components/Loading';
import Masthead from '@shell/components/ResourceList/Masthead';
import LinkDetail from '@shell/components/formatter/LinkDetail';

import { EPINIO_TYPES } from '../../../../types';
import { createEpinioRoute } from '../../../../utils/custom-routing';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const router = useRouter();

const resource = EPINIO_TYPES.APP;
const schema = ref(store.getters['epinio/schemaFor'](resource));

const headers = computed(() => store.getters['type-map/headersFor'](schema.value));
const groupBy = computed(() => store.getters['type-map/groupByFor'](schema.value));
const createLocation = computed(() =>
  createEpinioRoute('c-cluster-applications-createapp', { cluster: store.getters['clusterId'] })
);

const openCreateRoute = () => {
  router.push(createLocation.value);
};

const rows = computed(() => store.getters['epinio/all'](resource));

const pending = ref(true);

onMounted(async () => {
  await store.dispatch('epinio/findAll', { type: EPINIO_TYPES.APP });
  // Non-blocking fetch
  store.dispatch('epinio/findAll', { type: EPINIO_TYPES.CONFIGURATION });
  store.dispatch('epinio/findAll', { type: EPINIO_TYPES.SERVICE_INSTANCE });

  pending.value = false;
});

return (_ctx: any,_cache: any) => {
  return (pending.value)
    ? (_openBlock(), _createBlock(_unref(Loading), { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Masthead), {
          schema: schema.value,
          resource: _unref(resource)
        }, {
          createButton: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn role-primary",
              onClick: openCreateRoute
            }, _toDisplayString(_ctx.t('generic.create')), 1)
          ]),
          _: 1
        }, 8, ["schema", "resource"]),
        _cache[5] || (_cache[5] = _createTextVNode()),
        _createVNode(_unref(ResourceTable), {
          schema: schema.value,
          rows: rows.value,
          headers: headers.value,
          "group-by": groupBy.value
        }, {
          "cell:configurations": _withCtx(({ row }) => [
            (row.baseConfigurations.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.baseConfigurations, (configuration, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: configuration.id
                    }, [
                      _createVNode(_unref(LinkDetail), {
                        row: configuration,
                        value: configuration.meta.name
                      }, null, 8, ["row", "value"]),
                      _cache[0] || (_cache[0] = _createTextVNode()),
                      (index !== row.baseConfigurations.length - 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, ", "))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, " "))
          ]),
          "cell:services": _withCtx(({ row }) => [
            (row.services.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.services, (service, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: service.id
                    }, [
                      _createVNode(_unref(LinkDetail), {
                        row: service,
                        value: service.meta.name
                      }, null, 8, ["row", "value"]),
                      _cache[1] || (_cache[1] = _createTextVNode()),
                      (index !== row.services.length - 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, ", "))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, " "))
          ]),
          "cell:route": _withCtx(({ row }) => [
            (row.routes.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.routes, (route, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: route.id || route
                    }, [
                      (row.state === 'running')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: `https://${route}`,
                            target: "_blank",
                            rel: "noopener noreferrer nofollow"
                          }, _toDisplayString(`https://${route}`), 9, _hoisted_9))
                        : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(`https://${route}`), 1)),
                      _cache[2] || (_cache[2] = _createTextVNode()),
                      (index !== row.routes.length - 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, ", "))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, " "))
          ]),
          _: 1,
          __: [3,4]
        }, 8, ["schema", "rows", "headers", "group-by"])
      ]))
}
}

})